import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import OnMountHomeScroll from 'hoc/OnMountHomeScroll';
import { Footer } from '@goodwaygroup/ui-ux';
import moment from 'moment';
import { get } from 'lodash';


const Wrapper = styled.div`
    min-height: 100vh;
`;

const Header = styled.header``;

const SideBar = styled.div``;

const Title = styled.div``;

const Content = styled.section`
   margin: 30px 25px;
`;

const ContentWrapper = styled.div`
    float: right;
    min-height: calc(100vh - 100px);

   ${breakpoint('xs', 'md')`
        width: 100%;
    `}

    ${breakpoint('md', 'xl')`
        width:calc(100% - 200px);
    `}

    position: relative
`;

const AdminTemplate = ({
    header, sidebar, title, children, ...props
}) => (
    <Wrapper {...props}>
        <Header>{header}</Header>
        <SideBar>{sidebar}</SideBar>
        <ContentWrapper>
            <Title>{title}</Title>
            <Content>{children}</Content>
            {get(props.theme, 'whitelabel.showGGBranding', true) &&
                <Footer year={moment().year()} theme={props.theme} />}
        </ContentWrapper>
    </Wrapper>
);

AdminTemplate.propTypes = {
    header: PropTypes.node.isRequired,
    footer: PropTypes.node,
    title: PropTypes.node,
    children: PropTypes.any.isRequired,
};

export default OnMountHomeScroll()(withTheme(AdminTemplate));



// WEBPACK FOOTER //
// ./src/components/templates/Admin.js